import { CartAddEvent, ThemeEvents } from '@theme/events';

// Only successful add operations invite; quantity changes and page loads do not.
let generation = 0;
let invitedKey = '';
let popup;
let stopCelebration = () => {};
const enabled = document.querySelector('script[data-bogo-add-popup]')?.dataset.enabled === 'true';
async function cart() {
  const response = await fetch(`${Theme.routes.cart_url}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Cart unavailable');
  return response.json();
}
function eligible(value) {
  return value.item_count === 1 && value.items?.length === 1 && value.items[0].price > 0 && !value.items[0].properties?._bogo_claim && !value.items[0].properties?._byob_gift_type;
}
function createPopup() {
  if (popup) return popup;
  popup = document.createElement('dialog');
  popup.className = 'rtr-bogo-unlocked';
  popup.setAttribute('aria-labelledby', 'rtr-bogo-unlocked-title');
  popup.innerHTML = `<canvas class="rtr-bogo-unlocked__confetti" aria-hidden="true"></canvas><div class="rtr-bogo-unlocked__content"><span class="rtr-bogo-unlocked__badge">BUY 1 GET 1 FREE</span><h2 id="rtr-bogo-unlocked-title"><span aria-hidden="true">🎁</span> You’ve unlocked a free pair!</h2><p>Choose your second pair from your cart.<br>The cheaper pair is free.</p><button type="button" class="rtr-bogo-unlocked__continue" autofocus>Continue</button></div>`;
  popup.querySelector('.rtr-bogo-unlocked__continue').onclick = () => popup.close();
  popup.addEventListener('click', event => { if (event.target === popup) popup.close(); });
  popup.addEventListener('close', () => stopCelebration());
  popup.addEventListener('cancel', () => stopCelebration());
  document.body.append(popup);
  return popup;
}
// Two finite, physics-driven party-popper bursts. No library or network calls.
function celebrate(dialog) {
  stopCelebration();
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const canvas = dialog.querySelector('canvas');
  const context = canvas.getContext('2d');
  if (!context) return;
  const width = window.innerWidth, height = window.innerHeight;
  const scale = Math.min(window.devicePixelRatio || 1, 2);
  canvas.width = width * scale;
  canvas.height = height * scale;
  context.scale(scale, scale);
  const colors = ['#ff477e', '#24a8ff', '#ffcf24', '#38c98b', '#a570ff', '#ff823c', '#f85bc1'];
  const particles = Array.from({ length: 85 }, (_, index) => {
    const left = index % 2 === 0;
    return { x: left ? width * .08 : width * .92, y: height * .7,
      vx: (left ? 1 : -1) * (2 + Math.random() * 8), vy: -8 - Math.random() * 12,
      rotation: Math.random() * Math.PI, spin: (Math.random() - .5) * .3,
      size: 4 + Math.random() * 6, color: colors[index % colors.length], round: index % 4 === 0 };
  });
  let frame, previous, started;
  stopCelebration = () => { cancelAnimationFrame(frame); context.clearRect(0, 0, width, height); };
  function draw(time) {
    if (!dialog.open) { stopCelebration(); return; }
    started ??= time;
    const elapsed = time - started;
    const step = Math.min((time - (previous ?? time - 16.67)) / 16.67, 2);
    previous = time;
    context.clearRect(0, 0, width, height);
    context.globalAlpha = Math.max(0, Math.min(1, (3200 - elapsed) / 700));
    for (const piece of particles) {
      piece.vx *= Math.pow(.99, step); piece.vy += .3 * step;
      piece.x += piece.vx * step; piece.y += piece.vy * step; piece.rotation += piece.spin * step;
      context.save(); context.translate(piece.x, piece.y); context.rotate(piece.rotation);
      context.fillStyle = piece.color;
      if (piece.round) { context.beginPath(); context.arc(0, 0, piece.size / 2, 0, Math.PI * 2); context.fill(); }
      else context.fillRect(-piece.size / 2, -piece.size, piece.size, piece.size * 2 * Math.cos(elapsed / 180 + piece.rotation));
      context.restore();
    }
    if (elapsed < 3200) frame = requestAnimationFrame(draw);
    else stopCelebration();
  }
  frame = requestAnimationFrame(draw);
}
document.addEventListener(ThemeEvents.cartUpdate, async event => {
  const request = ++generation;
  if (!enabled) return;
  if (!(event instanceof CartAddEvent) || event.detail?.data?.didError) {
    if (event.detail?.resource?.item_count === 0) invitedKey = '';
    return;
  }
  try {
    const value = await cart();
    if (request !== generation) return;
    if (!eligible(value)) { popup?.close(); if (!value.item_count) invitedKey = ''; return; }
    const key = value.items[0].key;
    if (key === invitedKey) return;
    invitedKey = key;
    const dialog = createPopup();
    if (!dialog.open) {
      dialog.showModal();
      celebrate(dialog);
    }
  } catch (error) { console.warn('BOGO invitation skipped: cart unavailable', error); }
});
